import { IRegionPublicWaterSystemResult } from '../../types';

export const defaultRegionViolations: IRegionPublicWaterSystemResult[] = [
  {
      epaRegion: "4",
      violations: 1541958,
      region: "Region 04",
  },
  {
      epaRegion: "6",
      violations: 1312101,
      region: "Region 06",
  },
  {
      epaRegion: "3",
      violations: 1239290,
      region: "Region 03",
  },
  {
      epaRegion: "5",
      violations: 830904,
      region: "Region 05",
  },
  {
      epaRegion: "10",
      violations: 718355,
      region: "Region 10",
  },
  {
      epaRegion: "8",
      violations: 610959,
      region: "Region 08",
  },
  {
      epaRegion: "2",
      violations: 560507,
      region: "Region 02",
  },
  {
      epaRegion: "9",
      violations: 465679,
      region: "Region 09",
  },
  {
      epaRegion: "1",
      violations: 435243,
      region: "Region 01",
  },
  {
      epaRegion: "7",
      violations: 361390,
      region: "Region 07",
  }
]